import { taskManagerApiPaths } from '@/hooks/api/_paths'
import { useApiRequest } from '@/lib/http-utils'
import { useMutation, useQueryClient } from '@tanstack/react-query'

type DeleteAgentInput = {
  agentId: string
}

export function useDeleteAgentMutation(agentId: string) {
  const { apiRequest, domainId } = useApiRequest()
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['delete-agent', agentId],
    mutationFn: async ({ agentId }: DeleteAgentInput) => {
      const path = taskManagerApiPaths.agentById({ domainId, agentId })

      const response = await apiRequest({
        path,
        options: { method: 'DELETE' },
      })

      if (!response.ok) {
        throw new Error('FAILED_TO_DELETE_AGENT')
      }

      return true
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['agent-registry', domainId],
      })
    },
  })
}
